import { useCallback } from 'react';

const DOWNLOAD_FRAME_LIFETIME_MS = 60_000;

export const useFileDownload = () => {
    const getFileName = useCallback((res: Response) => {
        const disposition = res.headers.get('Content-Disposition');
        if (!disposition) {
            return '';
        }

        let matches = disposition.match(/filename\*=utf-8''([^\s;]+);?/i);
        if (matches?.length === 2) {
            return decodeURIComponent(matches[1]);
        }

        matches = disposition.match(/filename=([^\s;]+)/i);
        if (matches?.length === 2) {
            return matches[1];
        }

        return '';
    }, []);

    const triggerDownload = useCallback(
        (blob: Blob, response: Response) => {
            const url = URL.createObjectURL(blob);
            const linkElement = document.createElement('a');
            linkElement.style.display = 'none';
            linkElement.href = url;
            linkElement.download = getFileName(response);
            document.body.appendChild(linkElement);
            linkElement.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(linkElement);
        },
        [getFileName],
    );

    /**
     * Saves the file behind a URL whose response forces a download. A hidden frame loads it, so an error
     * response lands there instead of replacing the app or opening a tab. The sandbox allows only the
     * download, so a response that is rendered after all runs no script.
     */
    // @ai-generated 2026-09-28T06:54:35+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
    const triggerUrlDownload = useCallback((url: string) => {
        const frame = document.createElement('iframe');
        frame.style.display = 'none';
        frame.setAttribute('sandbox', 'allow-downloads');
        frame.src = url;
        document.body.appendChild(frame);
        setTimeout(() => frame.remove(), DOWNLOAD_FRAME_LIFETIME_MS);
    }, []);

    return {
        triggerDownload,
        triggerUrlDownload,
    };
};
